import { CalendarGranularity } from "PFApp/booking/types";
import MultiToggle from "PFComponents/multi_toggle";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { WorkforceCalendarData } from "../../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../../context/bookings_overview_context";
import css from "./granularity_selector.module.scss";

export const GranularitySelector = () => {
  const { t } = useTranslation("bookingModule");
  const {
    calendarData: { calendarGranularity, setCalendarGranularity }
  } = useBookingsOverviewContext<WorkforceCalendarData>();

  const options = useMemo(
    () => [
      {
        id: CalendarGranularity.Daily,
        value: t("workforce.granularity.daily")
      },
      {
        id: CalendarGranularity.Weekly,
        value: t("workforce.granularity.weekly")
      }
    ],
    [t]
  );

  return (
    <MultiToggle<CalendarGranularity>
      defaultSelected={calendarGranularity}
      options={options}
      onChange={setCalendarGranularity}
      classes={{
        root: css.root,
        container: css.multiToggleContainer
      }}
    />
  );
};
